module.exports = __webpack_public_path__ + "2fbc62f23fe83eb2f68cebb74bd9a7e6.jpg";